import styled from "styled-components";
import { IndicatorCard } from "components/ui/display/IndicatorCard";
import { ContentContainer } from "components/ui/display/ContentContainer";
import { useContext, useState } from "react";
import { TasksContext } from "providers/TasksProvider";
import { useErrors } from "providers/ErrorsProvider";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectDeliveries = ({content, handler}) => {

    const { setError, unsetError } = useErrors();

    const editDelivery = (delivery) => {

         const changesValidation = {
            deliveryTitle: true,
            deliveryContact: true,
        }

        if(delivery.title.length < 5)
        {
            setError("PROJECT_DELIVERIES_TITLE_TOO_SHORT");
            unsetError("PROJECT_DELIVERIES_TITLE_TOO_LONG");
            changesValidation.deliveryTitle = false;
        }
        else if(delivery.title.length > 30)
        {
            setError("PROJECT_DELIVERIES_TITLE_TOO_LONG");
            unsetError("PROJECT_DELIVERIES_TITLE_TOO_SHORT");
            changesValidation.deliveryTitle = false;
        }

        if(delivery.contact.length < 5)
        {
            setError("PROJECT_DELIVERIES_CONTACT_TOO_SHORT");
            unsetError("PROJECT_DELIVERIES_CONTACT_TOO_LONG");
            changesValidation.deliveryContact = false;
        }
        else if(delivery.contact.length > 30)
        {
            setError("PROJECT_DELIVERIES_CONTACT_TOO_LONG");
            unsetError("PROJECT_DELIVERIES_CONTACT_TOO_SHORT");
            changesValidation.deliveryContact = false;
        }

        if(!Object.values(changesValidation).every(Boolean)) return false;

        handler?.(prev => ({
            ...prev,
            deliveries: prev.deliveries.map(d => {
                if (d.deliveryUuid !== delivery.deliveryUuid) return d;

                return {
                    ...d,
                    title: delivery.title,
                    contact: delivery.contact
                };
            })
        }));

        return true;
    };

    const removeDelivery = (deliveryUuid) => {
        handler?.(prev => {
            let deliveries = [...prev.deliveries];
            deliveries = deliveries.filter(d => d.deliveryUuid !== deliveryUuid);

            return ({...prev, deliveries});
        })
    }

    const addDelivery = (delivery) => {
        
        const changesValidation = {
            deliveryTitle: true,
            deliveryContact: true,
        }

        if(delivery.title.length < 5)
        {
            setError("PROJECT_DELIVERIES_TITLE_TOO_SHORT");
            unsetError("PROJECT_DELIVERIES_TITLE_TOO_LONG");
            changesValidation.deliveryTitle = false;
        }
        else if(delivery.title.length > 30)
        {
            setError("PROJECT_DELIVERIES_TITLE_TOO_LONG");
            unsetError("PROJECT_DELIVERIES_TITLE_TOO_SHORT");
            changesValidation.deliveryTitle = false;
        }

        if(delivery.contact.length < 5)
        {
            setError("PROJECT_DELIVERIES_CONTACT_TOO_SHORT");
            unsetError("PROJECT_DELIVERIES_CONTACT_TOO_LONG");
            changesValidation.deliveryContact = false;
        }
        else if(delivery.contact.length > 30)
        {
            setError("PROJECT_DELIVERIES_CONTACT_TOO_LONG");
            unsetError("PROJECT_DELIVERIES_CONTACT_TOO_SHORT");
            changesValidation.deliveryContact = false;
        }
        
        if(!Object.values(changesValidation).every(Boolean)) return false;

        handler(prev => ({
            ...prev,
            deliveries: [
                ...prev.deliveries,
                {
                    deliveryUuid: crypto.randomUUID(),
                    title: delivery.title,
                    contact: delivery.contact
                }
            ]
        }));

        return true;
    }

    const { tasks } = useContext(TasksContext);
    let connectedTasks = 0;
    let connectedFinishedTasks = 0;
    content.deliveries.forEach(delivery => {
        const tsks = tasks.filter(tsk => tsk.taskDelivery === delivery.deliveryUuid && tsk.taskStatus !== "Finished").length;
        const finishedTsks = tasks.filter(tsk => tsk.taskDelivery === delivery.deliveryUuid && tsk.taskStatus === "Finished").length;
        connectedTasks += tsks;
        connectedFinishedTasks += finishedTsks;
    });

    return (
        <>
            <StyledProjectDeliveries>
                <div className="deliveriesHeader">
                    <div className="headerContainer">
                        <span>
                            Leveranseområder
                        </span>

                        Oprett og administrer leveranser i prosjektet.
                    </div>
                </div>
                <div className="deliveriesContent">
                    <div className="deliveriesIndicators">
                        <StyledIndicatorCard
                            dropShadow='sm'
                            title='Leveranseområder'
                            value={content.deliveries.length}
                            icon={<MaterialIcon
                                name='package_2'
                                weight={300}
                            />}
                            
                        />
                        <StyledIndicatorCard
                            dropShadow='sm'
                            title='Tilknyttede oppgaver'
                            value={connectedTasks}
                            icon={<MaterialIcon
                                name='ballot'
                                weight={300}
                            />}
                        />
                        <StyledIndicatorCard
                            dropShadow='sm'
                            title='Gjennomførte oppgaver'
                            icon={<MaterialIcon
                                name='check'
                                weight={300}
                            />}
                            value={connectedFinishedTasks}
                        />
                    </div>
                    <div className="deliveriesCards">
                        <NewDeliveryCard
                            onSubmit={addDelivery}
                        />
                        {
                            content.deliveries.map(d => <DeliveryCard key={d.deliveryUuid} delivery={d} onEdit={editDelivery} onRemove={removeDelivery}/>)
                        }
                    </div>
                </div>
            </StyledProjectDeliveries>
        </>
    )
}

const StyledProjectDeliveries = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};

    div.deliveriesHeader
    {
        display: flex;
        flex-wrap: wrap;
        gap: ${({theme}) => theme.spacing.lg};
        justify-content: space-between;
        align-items: center;

        div.headerContainer
        {
            span
            {
                display: block;
                font-weight: 600;
                font-size: ${({theme}) => theme.fontSize.lg};
                margin-bottom: ${({theme}) => theme.spacing.sm};
                color: ${({theme}) => theme.colors.neutralSecondaryForeground};
            }

            color: ${({theme}) => theme.colors.mutedForeground};
        }
    }

    div.deliveriesContent
    {
        div.deliveriesIndicators
        {
            display: flex;
            gap: ${({theme}) => theme.spacing.lg};
            flex-wrap: wrap;
            padding-bottom: ${({theme}) => theme.spacing.lg};
            border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            margin-bottom: ${({theme}) => theme.spacing.lg};
        }

        div.deliveriesCards
        {
            display: flex;
            flex-wrap: wrap;
            gap: ${({theme}) => theme.spacing.lg};
        }
    }
`

const StyledIndicatorCard = styled(IndicatorCard)`
    @media (min-width: ${({theme}) => theme.breakPoints.xxl})
    {
        width: calc((100% - 2 * ${({theme}) => theme.spacing.lg}) / 3);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xxl})
    {
        width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xl})
    {
        width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
    }

    @media (max-width: ${({theme})=> theme.breakPoints.lg})
    {
        min-width: 100%;
    }
`

const NewDeliveryCard = ({onSubmit}) => {
    
    const [newDelivery, setNewDelivery] = useState({
        title: '',
        contact: ''
    })

    return (
        <StyledDeliveryCard contentGap="sm" padding='md' paddingBottom='md'>
            <div className="cardHeader">
                    <div className="newDeliveryIcon">
                        <MaterialIcon
                            name='add'
                            weight={300}
                        />
                    </div>
                    
                </div>
                <div className="cardContent">
                    <input
                        className="deliveryTitleInput"
                        value={newDelivery.title}
                        onChange={(e) => setNewDelivery(prev => ({...prev, title: e.target.value}))}
                        placeholder="Tittel"
                    />

                    <div className="deliveryContactContainer">
                        <MaterialIcon
                            name='person'
                            weight={300}
                        />
                        <input
                            className="deliveryContactInput"
                            value={newDelivery.contact}
                            placeholder="Kontaktperson..."
                            onChange={(e) => setNewDelivery(prev => ({...prev, contact: e.target.value}))}
                        />
                        
                    </div>
                </div>
                <div className="cardFooter">
                    <MaterialIcon
                        name='arrow_forward'
                        weight={300}
                        onClick={() => {
                            let response = onSubmit(newDelivery);
                            if(response) setNewDelivery({title: '', contact: ''});
                        }}
                    />
                </div>
        </StyledDeliveryCard>
    )
}


const DeliveryCard = ({delivery, onEdit, onRemove}) => {

    const { tasks } = useContext(TasksContext);
    
    const filteredTasks = tasks.filter(tsk => tsk.taskDelivery === delivery.deliveryUuid);

    const [deliveryEdit, setDeliveryEdit] = useState(null);
    return (
        <StyledDeliveryCard contentGap="sm" padding='md' paddingBottom='md'>
            <div className="cardHeader">
                    <div className="deliveryIcon">
                        <MaterialIcon
                            name='package_2'
                            weight={300}
                        />
                    </div>
                    {
                        !deliveryEdit ?
                        <div className="editContainer">
                            <div className="expandOptionsIcon">
                                <MaterialIcon
                                    color={({theme}) => theme.colors.mutedForeground}
                                    weight={300}
                                    name='more_vert'
                                />
                            </div>
                            <div className="optionsContainer">
                                <MaterialIcon
                                    name='inventory_2'
                                    weight={300}
                                    color={({theme}) => theme.colors.errorForeground}
                                    onClick={() => onRemove(delivery.deliveryUuid)}
                                />
                                
                                <MaterialIcon
                                    name='edit'
                                    weight={300}
                                    color={({theme}) => theme.colors.mutedForeground}
                                    onClick={() => setDeliveryEdit({
                                        deliveryUuid: delivery.deliveryUuid,
                                        title: delivery.title,
                                        contact: delivery.contact
                                    })}
                                />
                                
                            </div>
                        </div>
                        : 
                        null
                    }
                </div>
                <div className="cardContent">
                    {
                        deliveryEdit
                        ?
                        <input
                            className="deliveryTitleInput"
                            value={delivery.title ? deliveryEdit.title : ''}
                            placeholder="Tittel"
                            onChange={(e) => {setDeliveryEdit(prev => ({...prev, title: e.target.value}))}}
                        />
                        :
                        <span className="deliveryTitle">
                            {delivery.title}
                        </span>
                    }
                
                    <div className="deliveryContactContainer">
                        <MaterialIcon
                            name='person'
                            weight={300}
                        />
                        {
                            deliveryEdit
                            ?
                            <input
                                className="deliveryContactInput"
                                value={delivery.contact ? deliveryEdit.contact : ''}
                                placeholder="Kontaktperson"
                                onChange={(e) => {setDeliveryEdit(prev => ({...prev, contact: e.target.value}))}}
                            />
                            :
                            <span className="deliveryContact">
                                {delivery.contact}
                            </span>
                        }
                        
                    </div>
                    
                </div>
                <div className="cardFooter">
                    {
                        deliveryEdit ?
                        <MaterialIcon
                            name='check'
                            weight={300}
                            onClick={() => {

                                const response = onEdit(deliveryEdit);

                                if(response) setDeliveryEdit(null);
                            }}
                        /> :
                        <div className="cardTasks">
                            <div title="Ikke igangsatt" className="cardTasksNotStarted">
                                {filteredTasks.filter(tsk => tsk && tsk.taskStatus === "NotStarted").length}
                            </div>
                            <div title="Igangsatt" className="cardTasksStarted">
                                {filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Started").length}
                            </div>
                            <div title="Stanset" className="cardTasksStopped">
                                {filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Stopped").length}
                            </div>
                            <div title="Fullført" className="cardTasksFinished">
                                {filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Finished").length}
                            </div>
                        </div>
                    }
                </div>
        </StyledDeliveryCard>
    )
}

const StyledDeliveryCard = styled(ContentContainer)`

    @media (min-width: ${({theme}) => theme.breakPoints.xxl})
    {
        width: calc((100% - 3 * ${({theme}) => theme.spacing.lg}) / 4);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xxl})
    {
        width: calc((100% - 2 * ${({theme}) => theme.spacing.lg}) / 3);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xl})
    {
        width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
    }

    @media (max-width: ${({theme}) => theme.breakPoints.lg})
    {
        min-width: 100%;
    }

    div.cardHeader
    {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        padding: ${({theme}) => theme.spacing.md};

        div.deliveryIcon
        {
            height: 38px;
            width: 38px;
            background: ${({theme}) => theme.colors.neutralSecondaryForeground};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${({theme}) => theme.colors.neutralSecondaryBackground};
            
            .icon
            {
                font-size: ${({theme}) => theme.iconSize.lg};
            }
            

        }

        div.newDeliveryIcon
        {
            height: 38px;
            width: 38px;

            background: ${({theme}) => theme.colors.neutralSecondaryBackground};
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            display: flex;
            align-items: center;
            justify-content: center;

            .icon
            {
                font-size: ${({theme}) => theme.iconSize.lg};
            }
        }
        
        div.editContainer
        {
            display: flex;
            align-items: center;

            .icon
            {
                cursor: pointer;
                font-size: ${({theme}) => theme.iconSize.sm};
            }

            div.expandOptionsIcon
            {
                transition-duration: 110ms;
                width: 24px;
                overflow: hidden;
            }

            div.optionsContainer
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.sm};
                align-items: center;
                overflow: hidden;
                width: 0;
                transition-duration: 110ms;
            }

            &:hover
            {
                div.optionsContainer
                {
                    width: 53px;
                }

                div.expandOptionsIcon
                {
                    width: 0;
                    opacity: 0;
                }
            }
        }
    }


    div.cardContent
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};

        input.deliveryTitleInput
        {
            border: 0;
            outline: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            background: ${({theme}) => theme.colors.neutralInputBackground};
            padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            font-size: ${({theme}) => theme.fontSize.md};
            font-weight: 600;
            height: calc(24px + 2 * ${({theme}) => theme.spacing.sm});
        }

        span.deliveryTitle
        {
            display: flex;
            height: calc(24px + 2 * ${({theme}) => theme.spacing.sm});
            padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            align-items: center;
            font-weight: 600;
        }

        div.deliveryContactContainer
        {
            align-items: center;
            display: flex;
            gap: ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
            color: ${({theme}) => theme.colors.mutedForeground};

            input.deliveryContactInput
            {
                border: none;
                outline: none;
                font-size: ${({theme}) => theme.fontSize.md};
                color: ${({theme}) => theme.colors.mutedForeground};
            }

            span.deliveryContact
            {
                color: ${({theme}) => theme.colors.mutedForeground};
            }

            &:has(input)
            {
                outline: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
                background: ${({theme}) => theme.colors.neutralInputBackground};
            }
        }
    }

    div.cardFooter
    {
        border-top: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        padding-top: ${({theme}) => theme.spacing.md};
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > .icon
        {
            cursor: pointer;
            font-size: ${({theme}) => theme.iconSize.sm};
        }

        > div.cardTasks
        {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: ${({theme}) => theme.spacing.sm};
            cursor: pointer;
            

            > div
            {
                padding: ${({theme}) => theme.spacing.xs} ${({theme}) => theme.spacing.lg};
                display: flex;
                justify-content: center;
                align-items: center;
                gap: ${({theme}) => theme.spacing.sm};

                &::before
                {
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: ${({theme}) => theme.cornerRadius.sm};
                }
            }
            
            div.cardTasksNotStarted::before
            {
                background: ${({theme}) => theme.colors.neutralSecondaryForeground};
            }

            div.cardTasksStarted::before
            {
                background: ${({theme}) => theme.colors.accentForeground};
            }

            div.cardTasksStopped::before
            {
                background: ${({theme}) => theme.colors.warningForeground};
            }

            div.cardTasksFinished::before
            {
                background: ${({theme}) => theme.colors.successForeground};
            }

            
        }
    }

`

